import "./Universal.css";
import React, { useEffect, useRef } from "react";
import { Grid, Button, Typography } from "@mui/material";
import { Send } from "@material-ui/icons";
import FormGroup from "./components/FormGroup";
import useFormValidation from "./hooks/useFormValidation";

const UniversalNew = ({ editing, universalID }: { editing: boolean; universalID: string }) => {
  const { register, control, handleSubmit, errors, loading, validationErrors, multiFieldArrays, handleBlur, onSubmit, formValues, formConfig } =
    useFormValidation({
      editing,
      universalID,
    });

  const prevFormValuesRef = useRef<string>("");

  useEffect(() => {
    const currentFormValuesString = JSON.stringify(formValues);
    if (currentFormValuesString !== prevFormValuesRef.current) {
      prevFormValuesRef.current = currentFormValuesString;
    }
  }, [formValues]);

  if (loading) return <Typography>მიმდინარეობს ჩატვირთვა...</Typography>;

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ width: "100%" }}>
      {formConfig.groups.map((group) => (
        <FormGroup
          key={group.name}
          group={group}
          fields={formConfig.fields}
          formValues={formValues}
          control={control}
          register={register}
          errors={errors}
          validationErrors={validationErrors}
          handleBlur={handleBlur}
          fieldArray={group.isMultiGroup ? multiFieldArrays[group.name] : undefined}
        />
      ))}

      <Grid container justifyContent="center" style={{ marginTop: "32px" }}>
        <Grid item xs={12} md={4}>
          <Button type="submit" variant="contained" color="primary" fullWidth startIcon={<Send />} disabled={loading}>
            გაგზავნა
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default UniversalNew;
